import { Center, Heading } from "@chakra-ui/react";
import Navbar from "../Components/Navbar";
import CartPage from "./Cart/CartPage";
export default function Cart(){
    return<div>
    <Navbar/>
       <CartPage/>
        
    </div>
}